
/* 
 *  This file city.model.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 2022  
 *  (C) 2015-2022. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *  
 */

import { PaginationModel, LinksModel, TKeyValue } from '../../../../../global/models/common.models';
import { FormControl } from '@angular/forms';

export enum cityUrls {
    cityCount = '/api/core/City/TotalCount',
    employeeCount = '/api/core/City/EmployeeCount/',
    search = '/api/core/City/Search',
    cityDropdown = '/api/core/City',
    stateDropdown = '/api/core/State',
    countryDropdown = '/api/core/Country',
    insert = '/api/core/City',
    update = '/api/core/City',
    delete = '/api/core/City',
}

export interface CityGridRequestModel {
    cityCode: string;
    stateCode: string;
    countryCode: string;
    globalRegionCode?: string;
    businessRegionCode?: string;
    districtCode?: string;
    cityStatus: string;
    pagination: PaginationModel;
}

export const cityGridRequestData: CityGridRequestModel = {
    cityCode: '',
    stateCode: '',
    countryCode: '',
    globalRegionCode: '',
    businessRegionCode: '',
    districtCode: '',
    cityStatus: '1',
    pagination: {
        pageNumber: 1,
        pageSize: 15
    }
};

export interface CityGridResponseModel {
    cityCode: string;
    cityName: string;
    stateCode: string;
    stateName: string;
    countryCode: string;
    countryName: string;
    globalRegionCode?: string;
    globalRegionName?: string;
    businessRegionCode?: string;
    businessRegionName?: string;
    districtCode?: string;
    districtName?: string;
    activeStatus: string;
    isMetro: boolean;
    links: LinksModel;
    // added
    employeeCount: string;
}

export interface CityFormData extends Pick<CityGridResponseModel, 'cityCode' | 'cityName' | 'stateCode' | 'countryCode' | 'activeStatus' | 'globalRegionCode' | 'businessRegionCode' | 'districtCode'> {}

export interface CityFilterModel {
    selected_global_region: TKeyValue<string, string>[];
    selected_business_region: TKeyValue<string, string>[];
    selected_district: TKeyValue<string, string>[];
    selected_country: TKeyValue<string, string>[];
    selected_state: TKeyValue<string, string>[];
    selected_city: TKeyValue<string, string>[];
    active: boolean;
    inactive: boolean;
    globalRegionCode: string;
    countryCode: string;
    businessRegionCode: string;
    stateCode: string;
    districtCode: string;
}

export const filterSkeleton: CityFilterModel = {
    selected_global_region: [],
    selected_country: [],
    selected_business_region: [],
    selected_state: [],
    selected_district: [],
    selected_city: [],
    active: true,
    inactive: false,
    globalRegionCode: '',
    countryCode: '',
    businessRegionCode: '',
    stateCode: '',
    districtCode: ''
};

export interface CityFormInterface {
    cityCode: FormControl<string | null>;
    cityName: FormControl<string | null>;
    globalRegionCode: FormControl<string | null>;
    countryCode: FormControl<string | null>;
    businessRegionCode: FormControl<string | null>;
    stateCode: FormControl<string | null>;
    districtCode: FormControl<string | null>;
    activeStatus: FormControl<string | null>;
}

export interface DropdownOption {
    key: string;
    value: string;
    globalRegionId?: string | number;
    stateCode?: string;
    countryCode?: string;
    businessRegionCode?: string;
}

export interface ConfirmDialog {
    show: boolean;
}

export interface CityPayload {
    cityCode: string;
    cityName: string;
    stateCode: string | null;
    countryCode: string | null;
    activeStatus: string | null;
    globalRegionCode: string | null;
    globalRegionName: string;
    businessRegionCode: string | null;
    businessRegionName: string;
    districtCode: string | null;
    districtName: string;
}
